import {useQuery, UseQueryResult} from '@tanstack/react-query';

import {fetchPhoneCommentVisibility, phoneCommentVisibilityUrl} from './phone-comment-visibility-api';
import {PhoneCommentVisibilityPayloadType, PhoneCommentVisibilityType} from './phone-comment-visibility-type';

// Whether the phone "Comment" field should be shown for the given companies: the backend answers
// yes when at least one of them pushes to Yandex Maps or 2GIS, the only catalogs that take it.
// Pass null while there is nothing to ask about — creating a company, for instance.
export function usePhoneCommentVisibility(
    payload: PhoneCommentVisibilityPayloadType | null
): UseQueryResult<PhoneCommentVisibilityType> {
    return useQuery({
        queryKey: [phoneCommentVisibilityUrl, JSON.stringify(payload)],
        queryFn: () => fetchPhoneCommentVisibility(payload as PhoneCommentVisibilityPayloadType),
        enabled: payload !== null,
        refetchOnWindowFocus: false,
    });
}
